'use strict';
const observable = require('@mindmup/mapjs-core/src/util/observable'),
	fileInfoFromFileListContext = require('./file-info-from-list-context');

module.exports = function GoldFilesPageController(goldFileListModel, authenticationModel, importModel, navigatorShim, subscriptionModel) {
	if (!goldFileListModel || !authenticationModel || !importModel || !navigatorShim) {
		throw new Error('invalid-args');
	}

	let selectedFileInfo = false;
	const dispatcher = observable(this),
		redirectToHomePage = function () {
			navigatorShim.reloadPage();
		},
		getFileKey = () => {
			if (!selectedFileInfo || !selectedFileInfo.fileId) {
				return false;
			}
			return `${selectedFileInfo.fileId}.pointer`;
		};

	['not-authenticated', 'authenticating'].forEach(evt => {
		authenticationModel.addEventListener(evt, () => dispatcher.dispatchEvent(evt));
	});

	goldFileListModel.addEventListener('context', (context) => {
		if (context && context.currentAction) {
			dispatcher.dispatchEvent(context.currentAction);
		} else {
			const fileInfo = fileInfoFromFileListContext(context);
			selectedFileInfo = fileInfo;
			if (fileInfo) {
				dispatcher.dispatchEvent('fileInfo', fileInfo);
			}
			dispatcher.dispatchEvent('ready');
		}
	});
	goldFileListModel.addEventListener('error', error =>  dispatcher.dispatchEvent('error', error));

	subscriptionModel.addEventListener('goldAccountInfo', accountInfo => {
		dispatcher.dispatchEvent('ready');
		if (accountInfo && accountInfo.subscription) {
			goldFileListModel.setAllowedActions(accountInfo.subscription.actions);
			goldFileListModel.load();
		}
	});
	authenticationModel.addEventListener('not-authenticated', () => {
		dispatcher.dispatchEvent('ready');
	});

	importModel.addEventListener('complete', () => goldFileListModel.load().catch(() => false));

	Object.freeze(Object.assign(this, {redirectToHomePage, getFileKey}));
};